/*!
 * Copyright Zendesk, Inc.
 * Use of this source code is governed under the Apache License, Version 2.0
 * found at http://www.apache.org/licenses/LICENSE-2.0
 */
!function (e, r) {
  for (var n in r) {
    e[n] = r[n];
  }
}(exports, function (e) {
  var r = {};

  function n(t) {
    if (r[t]) return r[t].exports;
    var o = r[t] = {
      i: t,
      l: !1,
      exports: {}
    };
    return e[t].call(o.exports, o, o.exports, n), o.l = !0, o.exports;
  }

  return n.m = e, n.c = r, n.d = function (e, r, t) {
    n.o(e, r) || Object.defineProperty(e, r, {
      enumerable: !0,
      get: t
    });
  }, n.r = function (e) {
    "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
      value: "Module"
    }), Object.defineProperty(e, "__esModule", {
      value: !0
    });
  }, n.t = function (e, r) {
    if (1 & r && (e = n(e)), 8 & r) return e;
    if (4 & r && "object" == typeof e && e && e.__esModule) return e;
    var t = Object.create(null);
    if (n.r(t), Object.defineProperty(t, "default", {
      enumerable: !0,
      value: e
    }), 2 & r && "string" != typeof e) for (var o in e) {
      n.d(t, o, function (r) {
        return e[r];
      }.bind(null, o));
    }
    return t;
  }, n.n = function (e) {
    var r = e && e.__esModule ? function () {
      return e.default;
    } : function () {
      return e;
    };
    return n.d(r, "a", r), r;
  }, n.o = function (e, r) {
    return Object.prototype.hasOwnProperty.call(e, r);
  }, n.p = "", n(n.s = 3);
}([function (e, r) {
  e.exports = require("@zendeskgarden/container-utilities");
}, function (e, r) {
  e.exports = require("react");
}, function (e, r) {
  e.exports = require("prop-types");
}, function (e, r, n) {
  "use strict";

  n.r(r);
  var t = n(1),
      o = n(0);

  function u(e, r) {
    var n = Object.keys(e);

    if (Object.getOwnPropertySymbols) {
      var t = Object.getOwnPropertySymbols(e);
      r && (t = t.filter(function (r) {
        return Object.getOwnPropertyDescriptor(e, r).enumerable;
      })), n.push.apply(n, t);
    }

    return n;
  }

  function c(e) {
    for (var r = 1; r < arguments.length; r++) {
      var n = null != arguments[r] ? arguments[r] : {};
      r % 2 ? u(n, !0).forEach(function (r) {
        i(e, r, n[r]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : u(n).forEach(function (r) {
        Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
      });
    }

    return e;
  }

  function i(e, r, n) {
    return r in e ? Object.defineProperty(e, r, {
      value: n,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : e[r] = n, e;
  }

  function a(e, r) {
    if (null == e) return {};

    var n,
        t,
        o = function (e, r) {
      if (null == e) return {};
      var n,
          t,
          o = {},
          u = Object.keys(e);

      for (t = 0; t < u.length; t++) {
        n = u[t], r.indexOf(n) >= 0 || (o[n] = e[n]);
      }

      return o;
    }(e, r);

    if (Object.getOwnPropertySymbols) {
      var u = Object.getOwnPropertySymbols(e);

      for (t = 0; t < u.length; t++) {
        n = u[t], r.indexOf(n) >= 0 || Object.prototype.propertyIsEnumerable.call(e, n) && (o[n] = e[n]);
      }
    }

    return o;
  }

  function f(e, r) {
    return function (e) {
      if (Array.isArray(e)) return e;
    }(e) || function (e, r) {
      if (!(Symbol.iterator in Object(e) || "[object Arguments]" === Object.prototype.toString.call(e))) return;
      var n = [],
          t = !0,
          o = !1,
          u = void 0;

      try {
        for (var c, i = e[Symbol.iterator](); !(t = (c = i.next()).done) && (n.push(c.value), !r || n.length !== r); t = !0) {
          ;
        }
      } catch (e) {
        o = !0, u = e;
      } finally {
        try {
          t || null == i.return || i.return();
        } finally {
          if (o) throw u;
        }
      }

      return n;
    }(e, r) || function () {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }();
  }

  function l() {
    var e = f(Object(t.useState)(!1), 2),
        r = e[0],
        n = e[1],
        u = Object(t.useRef)(void 0),
        i = Object(t.useRef)(!0);
    Object(t.useEffect)(function () {
      return function () {
        clearTimeout(u.current);
      };
    }, []);

    var l = function l() {
      i.current = !1, u.current = setTimeout(function () {
        i.current = !0;
      }, 0);
    },
        s = function s() {
      i.current && n(!0);
    },
        p = function p() {
      n(!1);
    };

    return {
      getFocusProps: function getFocusProps() {
        var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
            r = e.tabIndex,
            n = void 0 === r ? 0 : r,
            t = e.onBlur,
            u = e.onFocus,
            i = e.onMouseDown,
            f = e.onPointerDown,
            b = e.onTouchStart,
            d = a(e, ["tabIndex", "onBlur", "onFocus", "onMouseDown", "onPointerDown", "onTouchStart"]);
        return c({
          tabIndex: n,
          onBlur: Object(o.composeEventHandlers)(t, p),
          onFocus: Object(o.composeEventHandlers)(u, s),
          onMouseDown: Object(o.composeEventHandlers)(i, l),
          onPointerDown: Object(o.composeEventHandlers)(f, l),
          onTouchStart: Object(o.composeEventHandlers)(b, l),
          "data-garden-container-id": "containers.keyboardfocus",
          "data-garden-container-version": "0.2.7"
        }, d);
      },
      keyboardFocused: r
    };
  }

  var s = n(2),
      p = n.n(s);

  function b(e) {
    var r = e.children,
        n = e.render;
    return (void 0 === n ? r : n)(l());
  }

  b.propTypes = {
    children: p.a.func,
    render: p.a.func
  }, n.d(r, "useKeyboardFocus", function () {
    return l;
  }), n.d(r, "KeyboardFocusContainer", function () {
    return b;
  });
}]));